import React from 'react';
import './AccountInfo.scss';

interface AccountInfoProps {
  fullName: string;
  username: string;
  email: string;
  className?: string;
}

function AccountInfo(props: AccountInfoProps): JSX.Element {
  const { fullName, username, email, className } = props;
  const combinedClassName = `account-info ${className ? className : ''}`;
  return (
    <div className={combinedClassName}>
      <div className="account-info__field">
        <span className="account-info__title">Naam:</span>
        <span className="account-info__value">{fullName}</span>
      </div>
      <div className="account-info__field">
        <span className="account-info__title">Gebruikersnaam:</span>
        <span className="account-info__value">{username}</span>
      </div>
      <div className="account-info__field">
        <span className="account-info__title">E-mail adres:</span>
        <span className="account-info__value">{email}</span>
      </div>
    </div>
  );
}

export default AccountInfo;
